import { useState, useContext, useEffect } from 'react'
import { SceneContext } from './SceneContext'
import { useHistory }  from 'react-router-dom'
import './css/MapButton.css'

export default function MapButton({data, index, setLabel, type}) {
    const [style, setStyle] = useState(data.style)
    const [isHover, setHover] = useState(false)
    //const [hereStyle, setHereStyle] = useState({})
    const context = useContext(SceneContext)
    const history = useHistory()

    const isActive = history.location.pathname === '/'+data.nav_to
    let hereStyle = {} 

    //useEffect(()=>{setTimeout(()=>setStyle(data.style),100)}, [context.daylight])
    useEffect(()=>setStyle(data.style), [context.daylight])
    
    if(isActive) {
        let posible_active_mark_styles = {
            'to-scene': {
                top: data.style.top,
                left: data.style.left + (data.style.width||0)/2 - 26/2
            },
            'to-esquina': {
                top: data.style.top - 5,
                left: data.style.left + 17/2 - 26/2
            },
            'to-video': {
                top: data.style.top - 3,
                left: data.style.left + 26/2 - 26/2
            },
            'to-interior': {
                top: data.style.top - 3,
                left: data.style.left + 26/2 - 26/2
            }
        }

        hereStyle = posible_active_mark_styles[data.type]
    }
    
    const computeStyle = () => {
        let base = data.type +' selectable' 
        if(isActive)
            base = base + ' active'
        return base
    }

    const clickOnSelectable = (e) => {
        if(context.dev_mode)
            context.setMoveableElement(e)
        else {
            history.push(data.nav_to)
            context.change_display_map(false)
        }
    }

    const onEnter = () => {    
        setLabel(data.nav_to)   
        let new_style = {...data.style}
        if(data.type==='to-scene'){
            new_style.transform = new_style.transform + 'scale(1.05)'
        } else if(data.type==='to-esquina') {
            new_style.transform = 'rotate(45deg) scale(1.1)'
            new_style.backgroundColor = 'rgba(0, 148, 123, 0.8)'
        } 

        new_style.zIndex = 9999

        setStyle(new_style)
    }

    const onLeave = () => {
        setLabel('')
        setStyle(data.style)
    }

    const render_icon = () => {
        if(data.type==='to-interior') {
            return <img src="images/mapa/door.svg" />
        } else if(data.type==='to-video') {
            return <img src="images/mapa/video.svg" />
        } else if(data.type==='to-scene') {
            if(!isActive)
                return <img src="images/mapa/walk.svg" />
        }
    }

    return (
        <div>
            <div index={type+'-'+index} className={computeStyle()} style={style} onClick={clickOnSelectable} onMouseEnter={onEnter} onMouseLeave={onLeave}>
                { context.dev_mode? <div className="map-label">{data.label}</div> : '' }
                { render_icon() }
                {data.label? <div class="map-bot-label">{data.label}</div> : ''}
            </div>
            { isActive ? <img style={hereStyle} className="active-logo" src="images/mapa/here.svg" alt="" /> :''}
        </div>
        
    )
}